var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolMagneticRoi = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "square",
  d: "m12.5 6.5-4 3M6.5 12.5l-1 7"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.974 13.253 2.314 2.314M19.024 17.303l2.314 2.315M17.865 18.458a1.227 1.227 0 0 1-1.736-1.736l2.314-2.314a.844.844 0 0 0 0-1.157l-1.157-1.158a.844.844 0 0 0-1.157 0l-2.314 2.315c-1.917 1.917-1.469 4.317.289 6.075s4.158 2.206 6.075.29l2.314-2.315a.844.844 0 0 0 0-1.157l-1.157-1.157a.844.844 0 0 0-1.157 0l-2.314 2.314Z"
})), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 14.5,
  cy: 5.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 5.5,
  cy: 21.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 7,
  cy: 10.5,
  r: 1.5
}))));
export { SvgToolMagneticRoi as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-magnetic-roi.svg";